import styled from 'styled-components'

type Props = {
	isFullWidth?: boolean | undefined
	minWidth?: number
}

export const FieldWrapper = styled.div<Props>`
	display: ${({ isFullWidth }) => (isFullWidth ? 'block' : 'inline-block')};
	height: auto;
	margin-bottom: 4px;
	min-width: auto;
	overflow: visible;
`
